
import { useState } from 'react';
import { useNotifications } from './hooks/useNotifications';

export default function NotificationCenter() {
  const { all, markRead, markAllRead, deleteNotification } = useNotifications();
  const [filter, setFilter] = useState('all');

  if (all.isLoading) {
    return (
      <div className="p-6 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--color-primary)]"></div>
        <span className="ml-2">Loading...</span>
      </div>
    );
  }

  const notifications = all.data || [];
  const filteredNotifications = notifications.filter((notification: any) => {
    if (filter === 'unread') return !notification.read;
    if (filter === 'read') return notification.read;
    return true;
  });

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Notifications</h1>
        {notifications.some((n: any) => !n.read) && (
          <button
            onClick={() => markAllRead.mutate()}
            className="bg-[var(--color-primary)] text-white px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
          >
            Mark All Read
          </button>
        )}
      </div>

      {/* Filter Buttons */}
      <div className="flex gap-2 mb-4">
        {['all', 'unread', 'read'].map((filterType) => (
          <button
            key={filterType}
            onClick={() => setFilter(filterType)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
              filter === filterType
                ? 'bg-[var(--color-primary)] text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
            <span className="ml-1 text-xs">
              ({filterType === 'all' ? notifications.length :
                filterType === 'unread' ? notifications.filter((n: any) => !n.read).length :
                notifications.filter((n: any) => n.read).length})
            </span>
          </button>
        ))}
      </div>

      <div className="bg-white rounded shadow divide-y">
        {filteredNotifications.length > 0 ? (
          filteredNotifications.map((n: any) => (
            <div key={n.id} className={`p-3 flex justify-between ${n.read ? 'bg-gray-50' : 'bg-[var(--color-accent)]/20'}`}>
              <div className="flex-1">
                <h3 className="font-semibold">{n.title}</h3>
                <p className="text-sm text-gray-600">{n.message}</p>
                <p className="text-xs text-gray-400">{new Date(n.date).toLocaleString()}</p>
              </div>
              <div className="flex items-center space-x-2 ml-4">
                {!n.read && (
                  <button 
                    onClick={() => markRead.mutate(n.id)} 
                    className="text-sm text-[var(--color-primary)] hover:underline whitespace-nowrap"
                  >
                    Mark Read
                  </button>
                )}
                <button
                  onClick={() => deleteNotification.mutate(n.id)}
                  className="text-red-600 hover:text-red-700 text-sm"
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-12">
            <i className="ri-notification-off-line text-6xl text-gray-300 mb-4"></i>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No notifications</h3>
            <p className="text-gray-500">
              {filter === 'all' 
                ? "You're all caught up! No notifications to show." 
                : `No ${filter} notifications found.`}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
